import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appDisableInput]',
})
export class DisableInputDirective {
  input: HTMLInputElement;

  constructor(el: ElementRef) {
    this.input = el.nativeElement;
  }

  @HostListener('keydown', ['$event'])
  onKeyDown($event: KeyboardEvent) {
    $event.preventDefault();
  }

  @HostListener('paste', ['$event'])
  @HostListener('cut', ['$event'])
  onMouseEvents($event: KeyboardEvent) {
    $event.preventDefault();
  }
}



// WEBPACK FOOTER //
// ./src/app/common/directives/DisableInputDirective/disableInputDirective.ts